import React, { useEffect, useState }  from "react";
import { connect } from "react-redux";
import { Tabs } from "antd";
import { useParams } from 'react-router-dom';
import FarmerInfoForm from "./components/FarmerInfoForm";
import PersonalInfoForm from "./components/PersonalInfoForm";
import ContactDetailsForm from "./components/ContactDetailsForm";
import FarmProfileForm from "./components/FarmProfileForm";
import FarmParcelsTable from "../farm-parcels/components/FarmParcelsTable";
import { 
	getFarmerInfoDetails, doFarmerInfoCreate, doFarmerInfoUpdate 
} from "../../../redux/farmerinfo/farmerInfoState";

const { TabPane } = Tabs;

const ViewFarmerInfo = ({getRecord, doCreate, doUpdate, recordData, requesting, success, ...props}) => {
	const { farmerinformationId } = useParams();

	const [activeKey, setActiveKey] = useState("personal_info");
	
	const handleTabChange = (key) => {
		const currentURLWithoutFragment = window.location.href.split('#')[0] + '#' + key;
		window.history.replaceState({}, document.title, currentURLWithoutFragment);
		setActiveKey(key);
	}

	useEffect(() => {
		const tabKey = window.location.hash;
		if(tabKey && tabKey.length > 1){
			setActiveKey(tabKey.substring(1));
		}
	});

	useEffect(() => {
			getRecord(farmerinformationId);
		}, [farmerinformationId, getRecord]);

	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<Tabs type="card" size="large" activeKey={activeKey} onChange={handleTabChange}>
					<TabPane tab="Personal Information" key="personal_info">
						<PersonalInfoForm farmerId={farmerinformationId} recordId={recordData?.user_details_id} mode="view"/>
					</TabPane>

					<TabPane tab="Contact Details" key="contact_details">
						<ContactDetailsForm farmerId={farmerinformationId} recordId={recordData?.user_details_id} mode="view"/>
					</TabPane>

					<TabPane tab="Farmer Information" key="farmer_info">
						<FarmerInfoForm farmerId={farmerinformationId} recordId={recordData?.farmer_profile?.id} 
							mode="view"/>
					</TabPane>

					<TabPane tab="Farm Profile" key="farm_profile">
						<FarmProfileForm farmerId={farmerinformationId} recordId={recordData?.farmer_profile?.farm_profile?.id} mode="view"/>
					</TabPane>

					<TabPane tab="Farm Parcels" key="farm_parcels">
						<FarmParcelsTable farmerId={farmerinformationId} userDetailId={recordData?.user_details_id}/>
					</TabPane>
				</Tabs>
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
	recordData: state.farmerInfo.details?.data,
	requesting: state.farmerInfo.details?.requesting,
	success: state.farmerInfo.details?.success,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getFarmerInfoDetails(id)),
	doCreate: (data) => dispatch(doFarmerInfoCreate(data)),
	doUpdate: (data) => dispatch(doFarmerInfoUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewFarmerInfo);